//********************************** BLACKLIST ************************************\\
export const SCOPE_BLACK_LIST               = "SCOPE_BLACK_LIST";
export const BLACK_LIST_SCOPE_CREATE        = "SCOPE_BLACK_LIST_CREATE";
export const BLACK_LIST_SCOPE_EDIT          = "SCOPE_BLACK_LIST_EDIT";
export const BLACK_LIST_SCOPE_UPLOAD_FCA    = "SCOPE_BLACK_LIST_UPLOAD_FCA";
export const BLACK_LIST_SCOPE_DOWNLOAD      = "SCOPE_BLACK_LIST_DOWNLOAD";
export const BLACK_LIST_SCOPE_DETAIL_BL     = "SCOPE_BLACK_LIST_DETAIL_BL";
export const BLACK_LIST_SCOPE_ARCHIVE       = "SCOPE_BLACK_LIST_ARCHIVE";

//***************************** THEFT-MISSAPPROPRIATION *****************************\\
export const SCOPE_THEFT_MISAPPROPRIATION                       = "SCOPE_THEFT_MISAPPROPRIATION";
export const THEFT_MISAPPROPRIATION_SCOPE_CREATE                = "SCOPE_THEFT_MISAPPROPRIATION_CREATE";
export const THEFT_MISAPPROPRIATION_SCOPE_EDIT                  = "SCOPE_THEFT_MISAPPROPRIATION_EDIT";
export const THEFT_MISAPPROPRIATION_SCOPE_DETAIL                = "SCOPE_THEFT_MISAPPROPRIATION_DETAIL";
export const THEFT_MISAPPROPRIATION_SCOPE_EXPORT_TO_BE_CHARGED  = "SCOPE_THEFT_MISAPPROPRIATION_EXPORT_TO_BE_CHARGED";
export const THEFT_MISAPPROPRIATION_SCOPE_SEND_IN_INVOICING     = "SCOPE_THEFT_MISAPPROPRIATION_SEND_IN_INVOICING";
export const THEFT_MISAPPROPRIATION_SCOPE_ADD_CUSTOMER_BL       = "SCOPE_THEFT_MISAPPROPRIATION_ADD_CUSTOMER_BL";
export const THEFT_MISAPPROPRIATION_SCOPE_EDIT_STATE            = "SCOPE_THEFT_MISAPPROPRIATION_EDIT_STATE";
export const THEFT_MISAPPROPRIATION_SCOPE_EDIT_TO_BE_CHARGED    = "SCOPE_THEFT_MISAPPROPRIATION_EDIT_TO_BE_CHARGED";
export const THEFT_MISAPPROPRIATION_SCOPE_MESSAGES              = "SCOPE_THEFT_MISAPPROPRIATION_MESSAGES";

//***************************** FINES ***********************************************\\
export const SCOPE_FINES                = "SCOPE_FINES";
export const SCOPE_FINES_MANAGEMENT     = "SCOPE_FINES_MANAGEMENT";
export const FINES_SCOPE_VIEW           = "SCOPE_FINES_VIEW";
export const FINES_SCOPE_UPLOAD         = "SCOPE_FINES_UPLOAD";
export const FINES_SCOPE_TO_INVOICE     = "SCOPE_FINES_TO_INVOICE";
export const FINES_SCOPE_VIEW_CUSTOMER  = "SCOPE_VIEW_CUSTOMER_FINES";